import type { ProfileQuickAction } from '@trinity/chat/types/profile-config';

export type QuickAction = {
  displayValue: string;
  value: string;
};

export function buildQuickActions(items: ProfileQuickAction[]): QuickAction[] {
  return items
    .filter((action) => action.enabled)
    .map((action) => {
      const trimmedLabel = action.label.trim();
      const fallback = action.key.trim();
      const resolvedLabel = trimmedLabel || fallback;
      const resolvedValue = action.value?.trim() || resolvedLabel;

      return {
        displayValue: resolvedLabel,
        value: resolvedValue,
      };
    })
    .filter((action) => action.displayValue.length > 0 && action.value.length > 0);
}
